import { type EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForJWMExperiment(context: EditionAwarenessContextType): boolean {
	const {
		product,
		originalProjectTypeWasCore,
		isInCollection,
		userRoles,
		edition,
		isInTrial,
		isInPredunning,
		canUpgrade,
		canDirectBuyUpgrade,
		invoiceableStatus,
		canAddPaymentDetails,
	} = context;

	// Base checks for this experiment
	if (product === 'jira' && originalProjectTypeWasCore) {
		// Had to replicate from audience-and-timing to avoid having to expose this experiment on each modal that targets Jira
		const isInTrialOrPredunning = isInTrial || isInPredunning;

		const collectionWithPermissions =
			isInCollection &&
			userRoles?.includes('BILLING_ADMIN') &&
			(edition === 'free' || isInTrialOrPredunning);
		const freeEditionWithPermissions =
			!isInCollection && edition === 'free' && (canUpgrade || canDirectBuyUpgrade);
		const trialWithPermissions =
			!isInCollection &&
			(edition === 'standard' || edition === 'premium') &&
			isInTrialOrPredunning &&
			invoiceableStatus === 'NOT_INVOICEABLE' &&
			canAddPaymentDetails;

		return Boolean(collectionWithPermissions || freeEditionWithPermissions || trialWithPermissions);
	}
	return false;
}
